import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles'

const EmployerTermsAndConditions = ({ children }) => (
  <div className={styles.wrapper}>
    {children}
  </div>
)

EmployerTermsAndConditions.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})])),
    PropTypes.node,
  ]),
}

export default EmployerTermsAndConditions
